import styled from "styled-components";

export const LegendContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 26px;
`;

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #B8B4CC;
    margin-left: 10px;
    margin-bottom: 0px;
`;

export const Fieldset = styled.fieldset`
    width: 170px;

    @media (max-width: 600px){
        width: 100%
    }
`

export const Label = styled.label`
    font: normal normal normal 12px/16px Circular Std Book;
    color: #454546;
    margin-bottom: 16px;
`;

export const LabelInput = styled.label`
    font: normal normal normal 12px/16px Circular Std Book;
    color: #454546;
    margin-bottom: 8px;
`;

export const CheckContainer = styled.div`
    display: -webkit-flex;
    --webkit-box-align: center;
    margin-right: 20px;
    font: normal normal normal 9px/13px Circular Std Book;
    color: #454546;
    margin-bottom: 16px;
`;

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 26px;
`

export const Select = styled.select`
    width:100%;
    height: 31px;
    margin-right: 2px;
    background: #fff;
    color: #454546;
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid #eea94993;
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: #F6F5FA;
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`

export const TranparentButton = styled.button`
    font: normal normal normal 11px/15px Circular Std Book;
    color: #F58B1E;
    background-color: #FFF;
    border: 0px;
    outline: 0px;

    &:focus{
        outline: 0;
    }
`;

export const ButtonContainer = styled.div`
    width: 284px;
    margin-top: 47px;
    margin-bottom: 20px;

    @media (max-width: 600px) {
        width: 100%;
        margin-bottom: 70px;
    }
`;